import { useState } from 'react'

import { getTMinus1, toISO8601 } from '@fortem-monorepo/js-utilities'
import { DelayRender } from '@fortem-monorepo/react-spa'
import { HeaderConfigBar } from '@fortem-monorepo/react-spa'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@fortem-monorepo/react-ui'
import { ICGuidelines } from '@fortem-monorepo/web-sdk'

import { CanAccess } from '@/components/CanAccess'
import { Page } from '@/components/Page'
import { FUNDS } from '@/constants/links'
import { PERMISSIONS } from '@/constants/permissions'
import { GuidelineDrawer } from '@/pages/funds/ic-guidelines-v2/components/GuidelineDrawer'
import { GuidelineDrawerProvider } from '@/pages/funds/ic-guidelines-v2/components/GuidelineDrawerProvider'
import { ManageGuidelinesTab } from '@/pages/funds/ic-guidelines-v2/components/ManageGuidelinesTab'
import { ReportTab } from '@/pages/funds/ic-guidelines-v2/components/ReportTab'

export type GuidelineDrawerMode = 'create' | 'edit'

export interface GuidelineDrawerState {
  open: boolean
  mode: GuidelineDrawerMode
  guidelineId?: number
}

export type GuidelineDrawerActions = {
  openCreate: () => void
  openEdit: (guidelineId: number) => void
}

export interface IcGuidelinesV2PageProps {}

export const IcGuidelinesV2Page: React.FC<IcGuidelinesV2PageProps> = ({}) => {
  const [params, setParams] = useState<ICGuidelines.GetICGuidelinesParams>({
    fund_name: '',
    value_date: toISO8601(getTMinus1()),
  })

  return (
    <GuidelineDrawerProvider>
      <GuidelineDrawer />
      <Page metadata={{ title: 'IC Guidelines' }} permissions={FUNDS.IC_GUIDELINES.permissions}>
        <Tabs defaultValue={'report'} className={'gap-0 h-full'}>
          <CanAccess permissions={[PERMISSIONS.WRITE_IC_GUIDELINES]}>
            <HeaderConfigBar>
              <TabsList>
                <TabsTrigger value={'report'}>Report</TabsTrigger>
                <TabsTrigger value={'manage'}>Manage Guidelines</TabsTrigger>
              </TabsList>
            </HeaderConfigBar>
          </CanAccess>
          <div className="flex flex-col h-full relative">
            <TabsContent value="report">
              <DelayRender>
                <ReportTab params={params} setParams={setParams} />
              </DelayRender>
            </TabsContent>
            <TabsContent value="manage" className={'flex flex-col'}>
              <DelayRender>
                <ManageGuidelinesTab />
              </DelayRender>
            </TabsContent>
          </div>
        </Tabs>
      </Page>
    </GuidelineDrawerProvider>
  )
}
